export default function FeaturedProducts() {
  const products = [
    {
      id: 1,
      name: 'Crocs Personalizado Preto',
      price: '1.800 MZN',
      image: 'https://public.readdy.ai/ai/img_res/6ed11872f1146b66a6331aa68832729b.jpg',
      color: '#1F2937',
      description: 'Crocs preto estilo Bayaband com faixa lateral e pins decorativos'
    },
    {
      id: 2,
      name: 'Crocs Personalizado Azul Marinho',
      price: '1.800 MZN',
      image: 'https://readdy.ai/api/search-image?query=single%20navy%20blue%20Crocs%20Bayaband%20clog%20shoe%20with%20white%20stripe%20on%20side%20featuring%20red%20crocs%20logo%20text%2C%20decorated%20with%20colorful%20fun%20decorative%20pins%20charms%20on%20top%20including%20cartoon%20characters%20symbols%20icons%20and%20playful%20accessories%2C%20clean%20white%20background%2C%20professional%20product%20photography%20with%20soft%20shadows%20and%20bright%20studio%20lighting%20showing%20side%20view%20and%20customization%20details&width=800&height=800&seq=crocs-navy-bayaband-moz&orientation=squarish',
      color: '#1E3A8A',
      description: 'Crocs azul marinho estilo Bayaband com faixa lateral e pins decorativos'
    },
    {
      id: 3,
      name: 'Crocs Personalizado Vermelho',
      price: '1.800 MZN',
      image: 'https://readdy.ai/api/search-image?query=single%20bright%20red%20Crocs%20Bayaband%20clog%20shoe%20with%20white%20stripe%20on%20side%20featuring%20red%20crocs%20logo%20text%2C%20decorated%20with%20colorful%20fun%20decorative%20pins%20charms%20on%20top%20including%20cartoon%20characters%20symbols%20icons%20and%20playful%20accessories%2C%20clean%20white%20background%2C%20professional%20product%20photography%20with%20soft%20shadows%20and%20bright%20studio%20lighting%20showing%20side%20view%20and%20customization%20details&width=800&height=800&seq=crocs-red-bayaband-moz&orientation=squarish',
      color: '#DC2626',
      description: 'Crocs vermelho estilo Bayaband com faixa lateral e pins decorativos'
    },
    {
      id: 4,
      name: 'Crocs Personalizado Branco',
      price: '1.800 MZN',
      image: 'https://readdy.ai/api/search-image?query=single%20white%20Crocs%20Bayaband%20clog%20shoe%20with%20white%20stripe%20on%20side%20featuring%20red%20crocs%20logo%20text%2C%20decorated%20with%20colorful%20fun%20decorative%20pins%20charms%20on%20top%20including%20cartoon%20characters%20symbols%20icons%20and%20playful%20accessories%2C%20clean%20light%20gray%20background%2C%20professional%20product%20photography%20with%20soft%20shadows%20and%20bright%20studio%20lighting%20showing%20side%20view%20and%20customization%20details&width=800&height=800&seq=crocs-white-bayaband-moz&orientation=squarish',
      color: '#FFFFFF',
      description: 'Crocs branco estilo Bayaband com faixa lateral e pins decorativos'
    },
    {
      id: 5,
      name: 'Crocs Personalizado Rosa',
      price: '1.800 MZN',
      image: 'https://readdy.ai/api/search-image?query=single%20bright%20pink%20Crocs%20Bayaband%20clog%20shoe%20with%20white%20stripe%20on%20side%20featuring%20red%20crocs%20logo%20text%2C%20decorated%20with%20colorful%20fun%20decorative%20pins%20charms%20on%20top%20including%20cartoon%20characters%20symbols%20icons%20and%20playful%20accessories%2C%20clean%20white%20background%2C%20professional%20product%20photography%20with%20soft%20shadows%20and%20bright%20studio%20lighting%20showing%20side%20view%20and%20customization%20details&width=800&height=800&seq=crocs-pink-bayaband-moz&orientation=squarish',
      color: '#EC4899',
      description: 'Crocs rosa estilo Bayaband com faixa lateral e pins decorativos'
    },
    {
      id: 6,
      name: 'Crocs Personalizado Verde',
      price: '1.800 MZN',
      image: 'https://readdy.ai/api/search-image?query=single%20bright%20green%20Crocs%20Bayaband%20clog%20shoe%20with%20white%20stripe%20on%20side%20featuring%20red%20crocs%20logo%20text%2C%20decorated%20with%20colorful%20fun%20decorative%20pins%20charms%20on%20top%20including%20cartoon%20characters%20symbols%20icons%20and%20playful%20accessories%2C%20clean%20white%20background%2C%20professional%20product%20photography%20with%20soft%20shadows%20and%20bright%20studio%20lighting%20showing%20side%20view%20and%20customization%20details&width=800&height=800&seq=crocs-green-bayaband-moz&orientation=squarish',
      color: '#10B981',
      description: 'Crocs verde estilo Bayaband com faixa lateral e pins decorativos'
    },
    {
      id: 7,
      name: 'Crocs Personalizado Amarelo',
      price: '1.800 MZN',
      image: 'https://readdy.ai/api/search-image?query=single%20bright%20yellow%20Crocs%20Bayaband%20clog%20shoe%20with%20white%20stripe%20on%20side%20featuring%20red%20crocs%20logo%20text%2C%20decorated%20with%20colorful%20fun%20decorative%20pins%20charms%20on%20top%20including%20cartoon%20characters%20symbols%20icons%20and%20playful%20accessories%2C%20clean%20white%20background%2C%20professional%20product%20photography%20with%20soft%20shadows%20and%20bright%20studio%20lighting%20showing%20side%20view%20and%20customization%20details&width=800&height=800&seq=crocs-yellow-bayaband-moz&orientation=squarish',
      color: '#FBBF24',
      description: 'Crocs amarelo estilo Bayaband com faixa lateral e pins decorativos'
    },
    {
      id: 8,
      name: 'Crocs Personalizado Lilás',
      price: '1.800 MZN',
      image: 'https://readdy.ai/api/search-image?query=single%20bright%20lilac%20purple%20Crocs%20Bayaband%20clog%20shoe%20with%20white%20stripe%20on%20side%20featuring%20red%20crocs%20logo%20text%2C%20decorated%20with%20colorful%20fun%20decorative%20pins%20charms%20on%20top%20including%20cartoon%20characters%20symbols%20icons%20and%20playful%20accessories%2C%20clean%20white%20background%2C%20professional%20product%20photography%20with%20soft%20shadows%20and%20bright%20studio%20lighting%20showing%20side%20view%20and%20customization%20details&width=800&height=800&seq=crocs-lilac-bayaband-moz&orientation=squarish',
      color: '#A78BFA',
      description: 'Crocs lilás estilo Bayaband com faixa lateral e pins decorativos'
    },
    {
      id: 9,
      name: 'Crocs Personalizado Cinza',
      price: '1.800 MZN',
      image: 'https://readdy.ai/api/search-image?query=single%20gray%20Crocs%20Bayaband%20clog%20shoe%20with%20white%20stripe%20on%20side%20featuring%20red%20crocs%20logo%20text%2C%20decorated%20with%20colorful%20fun%20decorative%20pins%20charms%20on%20top%20including%20cartoon%20characters%20symbols%20icons%20and%20playful%20accessories%2C%20clean%20white%20background%2C%20professional%20product%20photography%20with%20soft%20shadows%20and%20bright%20studio%20lighting%20showing%20side%20view%20and%20customization%20details&width=800&height=800&seq=crocs-gray-bayaband-moz&orientation=squarish',
      color: '#6B7280',
      description: 'Crocs cinza estilo Bayaband com faixa lateral e pins decorativos'
    },
    {
      id: 10,
      name: 'Crocs Personalizado Laranja',
      price: '1.800 MZN',
      image: 'https://readdy.ai/api/search-image?query=single%20bright%20orange%20Crocs%20Bayaband%20clog%20shoe%20with%20white%20stripe%20on%20side%20featuring%20red%20crocs%20logo%20text%2C%20decorated%20with%20colorful%20fun%20decorative%20pins%20charms%20on%20top%20including%20cartoon%20characters%20symbols%20icons%20and%20playful%20accessories%2C%20clean%20white%20background%2C%20professional%20product%20photography%20with%20soft%20shadows%20and%20bright%20studio%20lighting%20showing%20side%20view%20and%20customization%20details&width=800&height=800&seq=crocs-orange-bayaband-moz&orientation=squarish',
      color: '#F97316',
      description: 'Crocs laranja estilo Bayaband com faixa lateral e pins decorativos'
    },
    {
      id: 11,
      name: 'Crocs Classic Preto',
      price: '1.800 MZN',
      image: 'https://readdy.ai/api/search-image?query=single%20black%20Crocs%20classic%20clog%20shoe%20with%20ventilation%20holes%20on%20top%2C%20decorated%20with%20colorful%20fun%20decorative%20pins%20charms%20including%20cartoon%20characters%20symbols%20icons%20and%20playful%20accessories%2C%20clean%20white%20background%2C%20professional%20product%20photography%20with%20soft%20shadows%20and%20bright%20studio%20lighting%20showing%20side%20view%20and%20customization%20details&width=800&height=800&seq=crocs-classic-black-moz&orientation=squarish',
      color: '#000000',
      description: 'Crocs clássico preto com pins decorativos variados'
    },
    {
      id: 12,
      name: 'Crocs Classic Azul Claro',
      price: '1.800 MZN',
      image: 'https://readdy.ai/api/search-image?query=single%20light%20blue%20Crocs%20classic%20clog%20shoe%20with%20ventilation%20holes%20on%20top%2C%20decorated%20with%20colorful%20fun%20decorative%20pins%20charms%20including%20cartoon%20characters%20symbols%20icons%20and%20playful%20accessories%2C%20clean%20white%20background%2C%20professional%20product%20photography%20with%20soft%20shadows%20and%20bright%20studio%20lighting%20showing%20side%20view%20and%20customization%20details&width=800&height=800&seq=crocs-classic-lightblue-moz&orientation=squarish',
      color: '#60A5FA',
      description: 'Crocs clássico azul claro com pins decorativos variados'
    },
    {
      id: 13,
      name: 'Crocs Classic Coral',
      price: '1.800 MZN',
      image: 'https://readdy.ai/api/search-image?query=single%20coral%20pink%20Crocs%20classic%20clog%20shoe%20with%20ventilation%20holes%20on%20top%2C%20decorated%20with%20colorful%20fun%20decorative%20pins%20charms%20including%20cartoon%20characters%20symbols%20icons%20and%20playful%20accessories%2C%20clean%20white%20background%2C%20professional%20product%20photography%20with%20soft%20shadows%20and%20bright%20studio%20lighting%20showing%20side%20view%20and%20customization%20details&width=800&height=800&seq=crocs-classic-coral-moz&orientation=squarish',
      color: '#FB7185',
      description: 'Crocs clássico coral com pins decorativos variados'
    },
    {
      id: 14,
      name: 'Crocs Classic Bege',
      price: '1.800 MZN',
      image: 'https://readdy.ai/api/search-image?query=single%20beige%20tan%20Crocs%20classic%20clog%20shoe%20with%20ventilation%20holes%20on%20top%2C%20decorated%20with%20colorful%20fun%20decorative%20pins%20charms%20including%20cartoon%20characters%20symbols%20icons%20and%20playful%20accessories%2C%20clean%20white%20background%2C%20professional%20product%20photography%20with%20soft%20shadows%20and%20bright%20studio%20lighting%20showing%20side%20view%20and%20customization%20details&width=800&height=800&seq=crocs-classic-beige-moz&orientation=squarish',
      color: '#D4A574',
      description: 'Crocs clássico bege com pins decorativos variados'
    },
    {
      id: 15,
      name: 'Crocs Classic Roxo',
      price: '1.800 MZN',
      image: 'https://readdy.ai/api/search-image?query=single%20purple%20Crocs%20classic%20clog%20shoe%20with%20ventilation%20holes%20on%20top%2C%20decorated%20with%20colorful%20fun%20decorative%20pins%20charms%20including%20cartoon%20characters%20symbols%20icons%20and%20playful%20accessories%2C%20clean%20white%20background%2C%20professional%20product%20photography%20with%20soft%20shadows%20and%20bright%20studio%20lighting%20showing%20side%20view%20and%20customization%20details&width=800&height=800&seq=crocs-classic-purple-moz&orientation=squarish',
      color: '#9333EA',
      description: 'Crocs clássico roxo com pins decorativos variados'
    },
    {
      id: 16,
      name: 'Crocs Classic Turquesa',
      price: '1.800 MZN',
      image: 'https://readdy.ai/api/search-image?query=single%20turquoise%20teal%20Crocs%20classic%20clog%20shoe%20with%20ventilation%20holes%20on%20top%2C%20decorated%20with%20colorful%20fun%20decorative%20pins%20charms%20including%20cartoon%20characters%20symbols%20icons%20and%20playful%20accessories%2C%20clean%20white%20background%2C%20professional%20product%20photography%20with%20soft%20shadows%20and%20bright%20studio%20lighting%20showing%20side%20view%20and%20customization%20details&width=800&height=800&seq=crocs-classic-turquoise-moz&orientation=squarish',
      color: '#14B8A6',
      description: 'Crocs clássico turquesa com pins decorativos variados'
    },
    {
      id: 17,
      name: 'Crocs Classic Limão',
      price: '1.800 MZN',
      image: 'https://readdy.ai/api/search-image?query=single%20lime%20green%20Crocs%20classic%20clog%20shoe%20with%20ventilation%20holes%20on%20top%2C%20decorated%20with%20colorful%20fun%20decorative%20pins%20charms%20including%20cartoon%20characters%20symbols%20icons%20and%20playful%20accessories%2C%20clean%20white%20background%2C%20professional%20product%20photography%20with%20soft%20shadows%20and%20bright%20studio%20lighting%20showing%20side%20view%20and%20customization%20details&width=800&height=800&seq=crocs-classic-lime-moz&orientation=squarish',
      color: '#84CC16',
      description: 'Crocs clássico limão com pins decorativos variados'
    },
    {
      id: 18,
      name: 'Crocs Classic Magenta',
      price: '1.800 MZN',
      image: 'https://readdy.ai/api/search-image?query=single%20magenta%20hot%20pink%20Crocs%20classic%20clog%20shoe%20with%20ventilation%20holes%20on%20top%2C%20decorated%20with%20colorful%20fun%20decorative%20pins%20charms%20including%20cartoon%20characters%20symbols%20icons%20and%20playful%20accessories%2C%20clean%20white%20background%2C%20professional%20product%20photography%20with%20soft%20shadows%20and%20bright%20studio%20lighting%20showing%20side%20view%20and%20customization%20details&width=800&height=800&seq=crocs-classic-magenta-moz&orientation=squarish',
      color: '#D946EF',
      description: 'Crocs clássico magenta com pins decorativos variados'
    },
    {
      id: 19,
      name: 'Crocs Classic Marrom',
      price: '1.800 MZN',
      image: 'https://readdy.ai/api/search-image?query=single%20brown%20chocolate%20Crocs%20classic%20clog%20shoe%20with%20ventilation%20holes%20on%20top%2C%20decorated%20with%20colorful%20fun%20decorative%20pins%20charms%20including%20cartoon%20characters%20symbols%20icons%20and%20playful%20accessories%2C%20clean%20white%20background%2C%20professional%20product%20photography%20with%20soft%20shadows%20and%20bright%20studio%20lighting%20showing%20side%20view%20and%20customization%20details&width=800&height=800&seq=crocs-classic-brown-moz&orientation=squarish',
      color: '#92400E',
      description: 'Crocs clássico marrom com pins decorativos variados'
    },
    {
      id: 20,
      name: 'Crocs Classic Pêssego',
      price: '1.800 MZN',
      image: 'https://readdy.ai/api/search-image?query=single%20peach%20orange%20Crocs%20classic%20clog%20shoe%20with%20ventilation%20holes%20on%20top%2C%20decorated%20with%20colorful%20fun%20decorative%20pins%20charms%20including%20cartoon%20characters%20symbols%20icons%20and%20playful%20accessories%2C%20clean%20white%20background%2C%20professional%20product%20photography%20with%20soft%20shadows%20and%20bright%20studio%20lighting%20showing%20side%20view%20and%20customization%20details&width=800&height=800&seq=crocs-classic-peach-moz&orientation=squarish',
      color: '#FDBA74',
      description: 'Crocs clássico pêssego com pins decorativos variados'
    }
  ];

  const handleWhatsAppClick = (productName: string) => {
    const message = `Olá! Gostaria de comprar o ${productName} por 1.800 MZN.`;
    window.open(`https://wa.me/258869689262?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <section id="produtos" className="py-24 px-6 bg-gradient-to-br from-orange-50 via-pink-50 to-yellow-50" data-product-shop>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-sm text-orange-600 font-semibold mb-2">• 20 Modelos Exclusivos</p>
          <h2 className="text-6xl font-bold text-gray-900 mb-4">Nossos Crocs Personalizados</h2>
          <p className="text-xl text-gray-600">Escolha sua cor favorita • Todos com pins decorativos • 1.800 MZN</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {products.map((product) => (
            <div
              key={product.id}
              className="bg-white rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group cursor-pointer"
            >
              <div className="relative aspect-square p-8 bg-gray-50">
                <div className="w-full h-full flex items-center justify-center">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
              </div>

              <div className="p-6 bg-white">
                <div className="flex items-center gap-3 mb-3">
                  <div
                    className="w-8 h-8 rounded-full border-2 border-gray-300"
                    style={{ backgroundColor: product.color }}
                  ></div>
                  <h3 className="text-lg font-bold text-gray-900">{product.name}</h3>
                </div>
                
                <p className="text-sm text-gray-600 mb-4">{product.description}</p>
                
                <p className="text-3xl font-bold text-orange-600 mb-4">{product.price}</p>

                <button
                  onClick={() => handleWhatsAppClick(product.name)}
                  className="w-full py-3 bg-green-500 text-white font-semibold rounded-xl hover:bg-green-600 transition-colors flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
                >
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-whatsapp-line text-xl"></i>
                  </div>
                  Comprar no WhatsApp
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-3 px-8 py-4 bg-white rounded-2xl shadow-lg">
            <div className="w-12 h-12 flex items-center justify-center bg-green-100 rounded-full">
              <i className="ri-whatsapp-line text-2xl text-green-600"></i>
            </div>
            <div className="text-left">
              <p className="text-sm text-gray-600">Dúvidas? Fale conosco</p>
              <p className="text-lg font-bold text-gray-900">+258 869 689 262</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
